import { Injectable } from '@angular/core';
import { GetDayViewArgs, GetDayViewHourGridArgs, getDayViewHourGrid, getDayView } from './day/utils';
import { DayView } from './day/DayView';
import { DayViewHour } from './day/DayViewHour';
import { CalendarEvent } from './CalendarEvent';
import {
  getMonthViewGrid,
  GetMonthViewGridArgs,
  GetMonthViewArgs,
  getWeekViewHeader,
  GetWeekViewHeaderArgs
} from '../utils/month/utils';

import { getWeekView } from '../utils/week/utils';

import { getScheduleView } from '../utils/schedule/utils';
export class CalendarUtilsService {
constructor() {

  }
/**
 * @param {?} args
 * @return {?}
 */
getScheduleView(args: any) {
    return getScheduleView(args);
  }
/**
 * @param {?} args
 * @return {?}
 */
getWeekView(args: any) {
    return getWeekView(args);
  }
/**
 * @param {?} args
 * @return {?}
 */
getMonthViewGrid(args: GetMonthViewGridArgs) {
    return getMonthViewGrid(args);
  }
/**
 * @param {?} args
 * @return {?}
 */
getWeekViewHeader(args: GetWeekViewHeaderArgs) {
    return getWeekViewHeader(args);
  }
/**
 * @param {?} args
 * @return {?}
 */
getDayView(args: GetDayViewArgs): DayView {
    return getDayView(args);
  }
/**
 * @param {?} args
 * @return {?}
 */
getDayViewHourGrid(args: GetDayViewHourGridArgs): DayViewHour[] {
    return getDayViewHourGrid(args);
  }


static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CalendarUtilsService_tsickle_Closure_declarations() {
/** @type {?} */
CalendarUtilsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CalendarUtilsService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
